module.exports = __webpack_public_path__ + "static/media/1014869.49b0ad3e.jpg";